'use client';

import React, { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { HeroUnsubscribe } from '@/components/Unsubscribe';
import { AdUnitContext } from '@/tracking/ads/components/AdUnitContext';
import { HeaderNav, HeaderNavCurLink } from '@/components/common/HeaderNav';
import { Footer } from '@/components/blocks/Footer';
import IntegrityError from '@/page-components/400';
import { fetchBackgroundImages } from '@/api/home/static';
import { IBackgroundImages } from '@/api/home/types';
import { Diagnostics } from '@/util/diagnostics';
import { useQueryWithInitialValue } from '@/util/useQueryWithInitialValue';

export type UnsubProps = {
  backgroundImage: IBackgroundImages;
};

export const DEBUG_TAG = 'unsubscribe-page';
export const TEMPLATE_ID = '9.9';
export const TEMPLATE_NAME = 'Unsubscribe Page';

export default function UnsubscribePage({ backgroundImage }: UnsubProps) {
  const searchParams = useSearchParams();
  const email = searchParams?.get('email') ?? '';
  const subid = searchParams?.get('subid') ?? '';

  const isValid = !!email && !!subid;

  useEffect(() => {
    if (!isValid) {
      Diagnostics.message({ message: 'Not a valid unsubscribe page' });
    }
  }, [isValid]);

  const {
    current: curBackgroundImage, hasFreshData: isImageFresh,
  } = useQueryWithInitialValue(['skireport-fetchBackgroundImages'],
    async () => fetchBackgroundImages(),
    backgroundImage);

  if (!isValid) {
    return <IntegrityError />;
  }

  return (
    <AdUnitContext adType="other" adTKey="unsubscibe">
      <div style={{ background: '#f4f5f5' }}>
        <HeaderNav current={HeaderNavCurLink.MAIN} />
        <HeroUnsubscribe
          email={email}
          subid={subid}
          loading={!isImageFresh}
          backgroundImage={curBackgroundImage}
        />
        <Footer />
      </div>
    </AdUnitContext>
  );
}
